// extracted by mini-css-extract-plugin
export default {"homeScreen":"HomeScreen_homeScreen__R91kw"};